/**
 * Wait for all promises to settle, but never longer than `maxMs`. The promises keep running in the
 * background when the wait gives up. Never rejects; always clears its timer.
 */
export async function boundedWait(promises: ReadonlyArray<Promise<unknown>>, maxMs: number): Promise<void> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    await Promise.race([
      Promise.allSettled(promises),
      new Promise<void>((resolve) => {
        timer = setTimeout(resolve, maxMs);
      }),
    ]);
  } finally {
    if (timer !== undefined) clearTimeout(timer);
  }
}
